function capitalizeFirstLetter(str: any) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export function capitalizeString(str: any) {
  
  const words = str?.split(' ');
  const transformedWords = words?.map((word: any, index: any) => {
    if (index === 0) {
      return capitalizeFirstLetter(word);
    } else {
      return word?.toLowerCase();
    }
  });

  return transformedWords?.join(' ');
}